import 'core-js/stable';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { StoreContext, store } from 'store/app';
import { TranslationsContext, translationsStore } from 'store/translations';
import 'dayjs/locale/ru';

const element = document.getElementById('root') as HTMLElement;
const root = createRoot(element);

root.render(
    <React.StrictMode>
        <StoreContext.Provider value={store}>
            <TranslationsContext.Provider value={translationsStore}>
                <App />
            </TranslationsContext.Provider>
        </StoreContext.Provider>
    </React.StrictMode>
);
